<template>
  <div>
    <b-card>
      <template slot="header">
        <b-card-title>
          <strong>{{title}}</strong>
          <p-button type="success" round size="sm" style="float:right;" @click.native="viewBilling">View Billing</p-button>
        </b-card-title>
        <p class="card-category mt-4 d-flex justify-content-between">
          <i class="text-dark">{{planDetail.title}}</i>
          <span class="text-muted">{{planDetail.cost}}</span>
        </p>
        <a class="text-info btn-change-subscription-plan mt-2" @click="changePlan">Change Plan &gt;</a>
      </template>
      <template slot="default">
        <b-row class="mt-4">
          <b-col>
            <b-card-title><strong>Monthly Cycle Usage</strong></b-card-title>
            <div class="section-monthly-usage d-flex flex-column justify-content-center align-items-center">
              <img src="@/assets/img/plan-graph.png" alt="" />
              <div class="text-center">
                <p class="h3 mb-0"><span>{{usage}}</span><span class="text-muted"> / {{planDetail.limit}}</span></p>
                <p class="text-muted"><small>monthly receipts</small></p>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-loading :loading="stripeSubscriptionLoading" />
      </template>
    </b-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import ModalBus from '@/buses/modal'

export default {
  data() {
    return {
      title: "Plan",
      processing: false,
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'isAuthenticated',
      'stripeCustomer',
      'stripeSubscriptionLoading',
    ]),
    planDetail: function() {
      if (!this.stripeCustomer) return {}
      if (this.user.subscription_plan === 'developer') {
        return {
          title: 'Developer',
          cost: '$0 / mo',
          limit: 200
        }
      } else {
        return {
          title: 'Business',
          cost: '$15 / mo',
          limit: 2500
        }
      }
    },
    usage: function() {
      return this.isAuthenticated && this.user.usage && this.user.usage.current || 0
    }
  },
  methods: {
    viewBilling() {
      this.$router.push('/settings')
    },
    changePlan() {
      ModalBus.$emit('subscriptionPlansModal.open')
    },
  }
}
</script>
<style lang="scss">
.btn-change-subscription-plan {
  cursor: pointer;
  display: inline-block;
}
.section-monthly-usage {
  min-height: 200px;
}
</style>